import React from 'react';
import PropTypes from "prop-types";
import NumberFormat from 'react-number-format';
import NumericSlider from "./NumericSlider";

function Euro(props) {
    const inputRef = React.createRef()
    if (props?.expandedStyle && props.expandedStyle!=='wizard') {
        return <ExpandedEuro {...props}/>
    }
    const handleBlur = function (e) {
        let val = e.target.value.replace(/\D/g, '')
        val = val === '' ? 0 : parseInt(val)
        props.setAnswer(val)
    }

    const wizardStyle = props.expandedStyle === 'wizard' ? 'transitionable delay-2':''
    const {className,...rest} = props.elementProps
    return <NumberFormat
        defaultValue={props.elementProps.defaultValue}
        displayType="tel"
        thousandSeparator={true}
        prefix="€"
        decimalScale={0}
        allowNegative={false}
        className={`form-control ${props.elementProps.className} euro ${wizardStyle} ${props?.expandedStyle||''}`}
        onBlur={handleBlur}
        getInputRef={inputRef}
        onKeyPress={(e)=>{if (e.key === 'Enter' || e.keyCode === 13) {e.target.blur()}}}
        {...rest}
    />
}

function ExpandedEuro(props) {
    const step = props.elementProps?.step || 100
    const setAnswer = (val)=>{
        props.setAnswer(parseInt(val))
    }

    return <NumericSlider
        prefix="€"
        step={step}
        min={props.elementProps.min}
        max={props.elementProps.max}
        label={props.label}
        setAnswer={setAnswer}
        error={props.elementProps.isInvalid}
        elementProps={{
            defaultValue: props.elementProps.defaultValue || '',
            isValid: props.elementProps.isValid,
            isInvalid: props.elementProps.isInvalid,
        }}
    />
}

Euro.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
};
export default Euro;